module.exports = __webpack_public_path__ + "static/img/logo3.22fcb57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo3.png
// module id = 2z9K
// module chunks = 1